import { render, staticRenderFns } from "./ServiceErrorDialog.vue?vue&type=template&id=5685722a&scoped=true"
import script from "./ServiceErrorDialog.vue?vue&type=script&lang=js"
export * from "./ServiceErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685722a",
  null
  
)

export default component.exports